<template>
  <img :key="training" :src="miniature" alt="nr" class="field nr" />
</template>

<script setup>
import { appStore } from "@/store";
import { computed } from "vue";

const training = computed(() => appStore.getters.getTrainingSelected);
const miniature = require(`./../assets/miniaturas/${training.value?.miniature}.png`);
</script>

<style scoped>
.field {
  position: absolute;
  font-size: 12pt;
  color: #000;
  z-index: 1;
}
.field.nr {
  top: 4mm;
  left: 13.5mm;
  width: 12%;
  height: 17%;
}
</style>
